import { useRef, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../common/axios";
import useGet from "../../hooks/useGet";
import { getErrors, hasData, toastDefault } from "../../utils/handler.utils";
import Loader from "../Loader/Loader";

function AddPackage(props) {
  const history = useHistory();
  const productId = props.match.params.id;

  const [loading, setLoading] = useState(null);
  const [autoDelivery, setAutoDelivery] = useState(false);
  const [isMultiple, setIsMultiple] = useState(false);
  const [childPackages, setChildPackages] = useState([]);
  const [selectedChild, setSelectedChild] = useState("");
  const [autoProductId, setAutoProductId] = useState(productId || "");
  const [products, loadingProducts] = useGet(`admin/topup-products`);
  const [packages, loadingPackages] = useGet(
    autoProductId ? `admin/topup-packages/${autoProductId}` : ""
  );

  const product_id = useRef(null);
  const mapPackage = useRef(null);
  const name = useRef(null);
  const sell_price = useRef(null);
  const buy_price = useRef(null);
  const tagRef = useRef(null);
  const voucherPrefixRef = useRef(null);
  const in_stock = useRef(null);
  const autoDeliveryRef = useRef(null);
  const selectedProduct = products?.find(
    (product) => String(product.id) === String(autoProductId || productId)
  );
  const isVoucherProduct = selectedProduct?.topup_type === "voucher";

  const addPackageHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    const autoDeliveryValue = autoDeliveryRef.current.checked ? 1 : 0;
    const isMultipleValue = autoDeliveryValue === 1 && isMultiple ? 1 : 0;

    const payload = {
      product_id: product_id.current.value,
      name: name.current.value,
      price: sell_price.current.value,
      buy_price: buy_price.current.value,
      tag: tagRef.current.value,
      in_stock: in_stock.current.checked ? 1 : 0,
      auto_delivery: autoDeliveryValue,
      isMultiple: isMultipleValue,
      childs: isMultipleValue ? childPackages : [],
    };

    if (isVoucherProduct) {
      payload.voucher_prefix = voucherPrefixRef.current?.value ?? "";
    }

    if (
      autoDeliveryValue === 1 &&
      isMultipleValue === 0 &&
      mapPackage?.current?.value
    ) {
      payload.map_voucher_package = mapPackage.current.value;
    }

    axiosInstance
      .post(`/admin/topup-package/add`, payload)
      .then((res) => {
        toast.success("Topup package created successfully", toastDefault);

        setTimeout(() => {
          history.push("/topup-packages");
        }, 1500);
      })
      .catch((err) => {
        toast.error(getErrors(err, false, true), toastDefault);
        setLoading(false);
      });
  };

  return (
    <section className="relative container_admin">
      <div className="bg-white overflow-hidden rounded">
        <div className="px-6 py-3 border-b border-gray-200">
          <h3 className="text-lg font-bold text-black">Add package</h3>
        </div>
        <div className="py-10 px-4">
          <div className="w-full md:w-[70%] min-h-[250px] mx-auto py-6 relative border border-gray-200 px-4">
            {loading || loadingProducts || loadingPackages ? (
              <Loader absolute />
            ) : (
              ""
            )}
            {hasData(products) && (
              <form onSubmit={addPackageHandler}>
                <div>
                  <div className="form_grid">
                    <div>
                      <label htmlFor="name">Product</label>
                      <select
                        defaultValue={productId}
                        ref={product_id}
                        className="form_input"
                        onChange={(e) => setAutoProductId(e.target.value)}
                      >
                        {products?.map((product) => (
                          <option value={product.id}>{product.name}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label htmlFor="name">Name</label>
                      <input
                        ref={name}
                        id="name"
                        className="form_input"
                        type="text"
                        placeholder="Name"
                        required
                      />
                    </div>
                  </div>
                  <div className="form_grid">
                    <div>
                      <label htmlFor="sell_price">Sell price</label>
                      <input
                        ref={sell_price}
                        id="sell_price"
                        className="form_input"
                        type="number"
                        placeholder="Sell price"
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="buy_price">Buy price</label>
                      <input
                        ref={buy_price}
                        id="buy_price"
                        className="form_input"
                        type="number"
                        placeholder="Buy price"
                        required
                      />
                    </div>
                  </div>

                  <div className="form_grid">
                    <div>
                      <label htmlFor="tag">Tag name</label>
                      <input
                        ref={tagRef}
                        id="tag"
                        className="form_input"
                        type="text"
                        placeholder="Tag"
                      />
                    </div>
                  </div>

                  {isVoucherProduct && (
                    <div className="form_grid">
                      <div>
                        <label htmlFor="voucher_prefix">Voucher prefix</label>
                        <input
                          ref={voucherPrefixRef}
                          id="voucher_prefix"
                          className="form_input"
                          type="text"
                          placeholder="Voucher prefix"
                        />
                      </div>
                    </div>
                  )}

                  <div className="form_grid">
                    <div>
                      <label class="inline-flex items-center">
                        <input
                          ref={in_stock}
                          id="in_stock"
                          value="1"
                          className="form-checkbox"
                          type="checkbox"
                        />
                        <span class="ml-2">In Stock</span>
                      </label>
                    </div>

                    <div>
                      <label class="inline-flex items-center">
                        <input
                          ref={autoDeliveryRef}
                          id="in_stock"
                          value="1"
                          onChange={() =>
                            setAutoDelivery(autoDeliveryRef.current.checked)
                          }
                          className="form-checkbox"
                          type="checkbox"
                        />
                        <span class="ml-2">Auto delivery</span>
                      </label>
                    </div>
                  </div>

                  {autoDelivery && (
                    <div className="space-y-4">
                      <div>
                        <label class="inline-flex items-center">
                          <input
                            id="is_multiple"
                            value="1"
                            onChange={() => setIsMultiple(!isMultiple)}
                            className="form-checkbox"
                            type="checkbox"
                            checked={isMultiple}
                          />
                          <span class="ml-2">Is multiple</span>
                        </label>
                      </div>

                      <div className="form_grid">
                        <div>
                          <label htmlFor="auto_product">Product</label>
                          <select
                            id="auto_product"
                            value={autoProductId}
                            onChange={(e) => setAutoProductId(e.target.value)}
                            className="form_input"
                          >
                            <option value="">Select A Product</option>
                            {products?.map((product) => (
                              <option value={product.id}>{product.name}</option>
                            ))}
                          </select>
                        </div>

                        {!isMultiple && (
                          <div>
                            <label htmlFor="map_package">Package Select</label>
                            <select
                              ref={mapPackage}
                              id="map_package"
                              className="form_input"
                            >
                              {loadingPackages && (
                                <option value="">Loading...</option>
                              )}
                              {!loadingPackages &&
                                packages?.map((pack) => (
                                  <option value={pack.id}>{pack.name}</option>
                                ))}
                            </select>
                          </div>
                        )}
                      </div>

                      {isMultiple && (
                        <div className="space-y-2">
                          <div className="form_grid">
                            <div>
                              <label htmlFor="multi_package_select">
                                Package Select
                              </label>
                              <div className="flex space-x-2">
                                <select
                                  id="multi_package_select"
                                  className="form_input"
                                  value={selectedChild}
                                  onChange={(e) =>
                                    setSelectedChild(e.target.value)
                                  }
                                >
                                  <option value="">Select package</option>
                                  {loadingPackages && (
                                    <option value="">Loading...</option>
                                  )}
                                  {!loadingPackages &&
                                    packages?.map((pack) => (
                                      <option value={pack.id}>
                                        {pack.name}
                                      </option>
                                    ))}
                                </select>
                                <button
                                  type="button"
                                  className="cstm_btn_small"
                                  onClick={() => {
                                    if (!selectedChild) return;
                                    setChildPackages((prev) => [
                                      ...prev,
                                      Number(selectedChild),
                                    ]);
                                    setSelectedChild("");
                                  }}
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                          <div>
                            <label className="block mb-1">
                              Selected packages
                            </label>
                            {childPackages?.length ? (
                              <ul className="space-y-1">
                                {childPackages.map((childId, index) => {
                                  const pkg =
                                    packages?.find(
                                      (pack) => Number(pack.id) === childId
                                    ) || null;
                                  return (
                                    <li
                                      key={`${childId}-${index}`}
                                      className="flex items-center justify-between bg-gray-100 px-2 py-1 rounded"
                                    >
                                      <span className="text-sm">
                                        {pkg?.name || "Package"} (ID: {childId})
                                      </span>
                                      <button
                                        type="button"
                                        className="text-red-600 text-sm"
                                        onClick={() =>
                                          setChildPackages((prev) =>
                                            prev.filter(
                                              (_, idx) => idx !== index
                                            )
                                          )
                                        }
                                      >
                                        Remove
                                      </button>
                                    </li>
                                  );
                                })}
                              </ul>
                            ) : (
                              <p className="text-sm text-gray-500">
                                No package selected yet.
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <div>
                    <button type="submit" className="cstm_btn w-full block">
                      Add package
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default withRouter(AddPackage);
